import { render, staticRenderFns } from "./KdsGestor.vue?vue&type=template&id=93950b0c&scoped=true"
import script from "./KdsGestor.vue?vue&type=script&lang=js"
export * from "./KdsGestor.vue?vue&type=script&lang=js"
import style0 from "./KdsGestor.vue?vue&type=style&index=0&id=93950b0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93950b0c",
  null
  
)

export default component.exports